import { commonTexts } from 'consts/text/index';
import { GroupStatus, LabelMapper } from 'types';

export const groupStatusesLabels: LabelMapper<GroupStatus> = {
    ACTIVE: commonTexts.dataLabels.activeFemale,
    ARCHIVED: commonTexts.dataLabels.archivedFemale,
};
